import type { SupplierCardResponse } from '../useQuerySuppliersOverview';

import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodSupplierCardResponseSchema } from '../useQuerySuppliersOverview/validations';

import { type AddNetworkSupplierPayload } from './types';
import { zodAddNetworkSupplierPayloadSchema } from './validations';

/**
 * Opens a DataExchange with an on-network supplier; idempotent on
 * (sender_id, receiver_id). When isRelevant=true, also marks the DE
 * relevant with priority_tier='regular'.
 *
 * @param payload - The supplier company ID, recipient company ID, and optional relevance flag.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The created or existing SupplierCardOverviewItem.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/post_suppliers_network_add_suppliers_network_add_post
 */
export const addNetworkSupplier = async (
  payload: AddNetworkSupplierPayload,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .post(ENDPOINT.SUPPLIER.ADD_NETWORK_SUPPLIER(), {
      json: payload,
      ...options,
      validate: {
        body: zodAddNetworkSupplierPayloadSchema,
        response: zodSupplierCardResponseSchema,
      },
    })
    .json<SupplierCardResponse>();
